var lrbarWidth, rlbarWidth, screenWidth, screenHeight, scrollDelta = 5, scrollDir = 'down', topOffset = 200, bottomOffset = 50, yPercent = 0;

window.addEventListener('pplrAppInitiated' , function(e) {
  $('.hide').removeClass('hide');
});

$(window).on('pageshow', function() {
  console.log('check page show');
 $('body').on('click', '.agp__buttonType__buttonContainer--fail input', function(e) {
   e.preventDefault();
   window.location.href = 'https://drinkwise.org.au/';
 });
 setTimeout(function() {
   // Get the elements
   var scroller = $('#scrolling-slider');
   var lr = $('#scrolling-slider .scroll-wrapper.lr');
   var rl = $('#scrolling-slider .scroll-wrapper.rl');
   // Get the slider row widths and window width
   if (lr.length > 0) {
     lrbarWidth = lr.get(0).scrollWidth;
     rlbarWidth = rl.get(0).scrollWidth;
     screenWidth = $(window).width();
   
     // Set start positions for both rows
     var lrXPos = 0;
     var rlXPos = rlbarWidth - screenWidth;
     lr.scrollLeft(lrXPos);
     rl.scrollLeft(rlXPos);
     var sliderTop = $('#scrolling-slider').offset().top - topOffset;
   
     $(window).scroll(function() {
       // Get the positions for scroll and the element
       var newScrollPosition = $(window).scrollTop();
       var bounds = document.getElementById('scrolling-slider').getBoundingClientRect();
       if (isInViewport(document.getElementById('scrolling-slider'))) {
         // Only calculate the horizontal scroll if the element is in the visible area
         yPercent = 1 - bounds.top / window.innerHeight; // How far up the visible area is the slider
         lr.scrollLeft((lrbarWidth - screenWidth) * yPercent);
         rl.scrollLeft(rlXPos - ((rlbarWidth - screenWidth) * yPercent)); // Invert the direction
       }
     });
   }
 }, 1500);

  $('body').on('click', '#personalise-form:not(.personalise-minis):not(.rose-package) .pplr-line-2 .pplr-selecter-options span', function(e) {
    var font = $(this).attr('data-name');
    console.log('selected font', font, $('#personalise-form .pplr-selecter-options span[data-name="'+font+'"]:not(.selected-font)'));
    $('#personalise-form .pplr-selecter-options span[data-name="'+font+'"]:not(.selected-font)').trigger('click');
  });
  $('body').on('click', '#personalise-form.personalise-minis .pplr-font-select.pplr-bottle-24 .pplr-selecter-options span', function(e) {
    var font = $(this).attr('data-name');
    console.log('selected font', font, $('#personalise-form .pplr-selecter-options span[data-name="'+font+'"]:not(.selected-font)'));
    $('#personalise-form.personalise-minis .pplr-font-select:not(.pplr-bottle-24):not(.pplr-label-for-all-bottles) .pplr-selecter-options span[data-name="'+font+'"]:not(.selected-font)').trigger('click');
  });
  $('body').on('click', '#personalise-form.rose-package .pplr-font-select[data-frame="4"] .pplr-selecter-options span', function(e) {
    var font = $(this).attr('data-name');
    console.log('selected font', font, $('#personalise-form .pplr-selecter-options span[data-name="'+font+'"]:not(.selected-font)'));
    $('#personalise-form.rose-package .pplr-font-select:not([data-frame="4"]) .pplr-selecter-options span[data-name="'+font+'"]:not(.selected-font)').trigger('click');
  });

  
//  $('#personalise-form:not(.no-convert)  input[type="text"].pplr_monogram').on('keyup', function(e) {
//    console.log('change string', $(this).val(), 'to', $(this).val().toLowerCase().replace(/[a-z0-9_\-\']*/g, (w) => (w.replace(/^[a-z0-9_\-\']/, (c) => c.toUpperCase()))));
//    $(this).val($(this).val().toLowerCase().replace(/[a-z0-9_\-\']*/g, (w) => (w.replace(/^[a-z0-9_\-\']/, (c) => c.toUpperCase()))));
//  });
  $('#personalise-form  input[type="text"].pplr_monogram').on('keyup', function(e) {
    if ($('.pplr-font-select.pplr-line-2 .selected-font').text().toLowerCase() == 'trenda') {
      $(this).val($(this).val().toUpperCase());
    }
    else {
      $(this).val($(this).val().toLowerCase().replace(/[a-z0-9_\-\']*/g, (w) => (w.replace(/^[a-z0-9_\-\']/, (c) => c.toUpperCase()))));
    }
  });

  /*$('#personalise-form  input[type="text"].pplr_monogram').on('keyup', function(e) {
    // Check for profanity
    let customSwears = [
"*",
"1519 tequila",
"1800 tequila",
"2ekhtah",
"2emmah",
"3 amigos tequila",
"3akrouteh",
"4 copas",
"42 below",
"50 yard cunt punt",
"7 leguas",
"a de fussigny",
"a. soutiran",
"abbey street",
"abelž",
"aberfeldy",
"aberlour",
"abruti",
"absolut",
"absolwent",
"adelphi",
"adet",
"adnams",
"ae dor",
"aguila superior tequila",
"ahole",
"akrouteh",
"alabama hot pocket",
"albert robin",
"albyn",
"alcoolique",
"alcoolisž",
"alfred gratien",
"allah",
"allt a bhainne",
"amcik",
"an cnoc",
"anal impaler",
"analconda",
"anale",
"analphabte",
"andhra black cobra",
"andouille",
"andskota",
"anestasia vodka",
"annandale",
"anus",
"ardlussa",
"ardmore",
"arette",
"argyll",
"arsch",
"arschfotze",
"arschgeige",
"arschgesicht",
"arschloch",
"arschloch",
"arse",
"arseh0le",
"arsehole",
"arsouille",
"arta tequila",
"artic",
"as useful as tits on a bull",
"ash0le",
"aspirateur",
"ass",
"ass fuck",
"assbag",
"assbandit",
"assbanger",
"assbite",
"assclown",
"asscock",
"asscracker",
"asses",
"assface",
"assfuck",
"assfucker",
"assgoblin",
"assh0le",
"asshat",
"ass-hat",
"asshead",
"asshole",
"assholz",
"asshopper",
"assistž",
"ass-jabber",
"assjacker",
"asskisser",
"asslick",
"asslicker",
"assmonkey",
"assmucus",
"assmunch",
"assmuncher",
"assnigger",
"asspirate",
"ass-pirate",
"assrammer",
"assshit",
"assshole",
"asssucker",
"asswad",
"asswipe",
"asticot",
"atardž",
"auchentoshan",
"auchinblae",
"auchnagie",
"auchroisk",
"auchtermuchty",
"auchtertool",
"augier",
"aultmore",
"averys",
"avion tequila",
"aviv 613",
"avoniel",
"avorton",
"axwound",
"ayala",
"ayir",
"ayre",
"ayreh",
"azunia tequila",
"azzhole",
"b!tch",
"b00b",
"b17ch",
"b1tch",
"babache",
"baby arm",
"bache gabrielsen",
"bachibouzouk",
"bachi-bouzouk",
"balblair",
"ballechin",
"ballindalloch",
"balls",
"ballsack",
"balmenach",
"baltringue",
"balvenie",
"bampot",
"bandžcon",
"bandon",
"banff",
"bang (one's) box",
"bankhall",
"bankier",
"barnett & fils",
"barvok vodka",
"bassterd",
"bastard",
"basterd",
"batard",
"bã¢tard",
"bate",
"beaner",
"beastial",
"beastiality",
"beastility",
"beaver",
"bžcasse",
"beef curtains",
"bžgueule",
"belaya rus",
"bellend",
"ben nevis",
"ben wyvis",
"benachie",
"benmore",
"benriach",
"benrinnes",
"benromach",
"bent",
"berry bros",
"berry bros & rudd",
"besame el culo",
"bestial",
"bestiality",
"bi7ch",
"biala dama",
"biatch",
"bigleux",
"billecart-salmon",
"binet",
"binge",
"bint",
"birr",
"bishopswater",
"bisnotch",
"bisquit",
"bitch",
"bitchass",
"bitchass mother fucker",
"bitcher",
"bitchers",
"bitches",
"bitchin",
"bitching",
"bitchtits",
"bitchy",
"biture",
"black bush",
"bladnoch",
"blair athol",
"blaireau",
"blavod",
"bleubite",
"bloede kuh",
"bloodclaat",
"bloody",
"bloody hell",
"blow job",
"blow me",
"blowjob",
"blue waffle",
"blumpkin",
"blunt",
"blutige sau",
"blvde fotze",
"blvdes arschloch",
"boffing",
"boiolas",
"boizel",
"bollinger",
"bollock",
"bollocks",
"bollok",
"bollox",
"boloss",
"bols",
"boludo",
"bombora",
"bon accord",
"bonehead",
"boner",
"bo'ness",
"bong spirit",
"boob",
"bordel",
"boudin",
"bouffon",
"bougre",
"boulard",
"boulet",
"bouricot",
"bourique",
"bourrž",
"bourrin",
"boursemolle",
"boursouflure",
"bouseux",
"boutonneux",
"bow street",
"bowman's",
"bowmore",
"boyd & blair",
"brackla",
"braes of glenlivet",
"braeval",
"branleur",
"branlotin",
"branque",
"branquignole",
"brechin",
"brle",
"brice",
"brigand",
"bristol",
"brora",
"brotherfucker",
"brown-cap",
"browneye",
"browntown",
"bruichladdich",
"brun",
"bruno paillard",
"brusna",
"bruto",
"buceta",
"bucket",
"buckle buffer",
"buggar",
"bugger",
"bugger me",
"bugger off",
"buggery",
"built like a brick shit-house",
"bukkake",
"bull",
"bulle",
"bullshit",
"bum",
"bumblefuck",
"bumsen",
"bung",
"bunnahabhain",
"burne",
"burnside",
"burtin - besserat de bellefon",
"bushmills",
"bust a load",
"butch",
"butor",
"butt",
"butt breath",
"butt fuck",
"butt fucker",
"butt hair",
"butt plug",
"buttface",
"buttfuck",
"buttfucka",
"buttfucker",
"butthead",
"butthole",
"buttpicker",
"butt-pirate",
"buttplug",
"buttwipe",
"c***",
"c**t",
"c**ts",
"c0ck",
"c0k",
"cabo wabo",
"cabron",
"cabrã³n",
"cabrã³n",
"cagar",
"cagas",
"cageot",
"cagole",
"caillera",
"caledonian",
"calvet",
"cambus",
"camel toe",
"cameronbridge",
"campbeltown",
"campeã³n",
"camus",
"canaille",
"canaillou",
"canard-duchne",
"cancrelat",
"caol ila",
"cape north",
"caperdonich",
"cara de mierda",
"carajo",
"cardhu (cardow)",
"carpetmuncher",
"carsebridge",
"casa dragones",
"casa noble",
"casamigos",
"casse-couilles",
"catin",
"cattier",
"cawk",
"cazadores",
"cazzo",
"ccatophile",
"cerote",
"chacal",
"chamucos",
"chanoine frres",
"chaoui",
"charles heidsieck",
"charles lafitte",
"charles mignon-lžon launois",
"charmouta",
"charogne",
"chase",
"chateau de beaulon",
"chateau montifaud",
"chaya tequila",
"chenapan",
"chesticle",
"chiassard",
"chiasse",
"chiennasse",
"chienne",
"chier",
"chieur",
"child-fucker",
"chinaco",
"chinc",
"chinga",
"chinga tu madre",
"chingada",
"chingado",
"chingado",
"chingalos",
"ch’galos",
"chingao",
"chingaos",
"chingar",
"chingarlos",
"chingarnos",
"chingarte",
"chingate",
"ch’gate",
"chingatelos",
"ch’gatelos",
"chinggis",
"chingo",
"chingon",
"chingã³n",
"chinguen",
"chink",
"chiottes enfoirž",
"chiure",
"choad",
"chode",
"chopin",
"chota bags",
"chraa",
"christ",
"chucha",
"chuj",
"chupã¡mela",
"cinglž",
"cipa",
"cã®roc",
"cirrus",
"ck vodka",
"clampin",
"cleveland steamer",
"clique",
"clit",
"clit licker",
"clitface",
"clitfuck",
"clitty litter",
"clochard",
"clodo",
"cloporte",
"clunge",
"clusterfuck",
"clydesdale",
"clynelish",
"cnts",
"cntz",
"cobia",
"cocaine",
"cochon",
"cock",
"cock cheese",
"cock jockey",
"cock pocket",
"cock snot",
"cockass",
"cockbite",
"cockburger",
"cockburn",
"cockface",
"cockfucker",
"cockhead",
"cockjockey",
"cock-juggling thunder cunt",
"cockknoker",
"cockmaster",
"cockmongler",
"cockmongruel",
"cockmonkey",
"cockmuncher",
"cocknose",
"cocknugget",
"cocks",
"cockshit",
"cocksmith",
"cocksmoke",
"cocksmoker",
"cocksniffer",
"cocksuck",
"cocksucked",
"cocksucker",
"cocksucking",
"cocksucks",
"cockwaffle",
"cocu",
"cojon",
"cojã³n",
"coke",
"coleburn",
"coleraine",
"comber lower",
"comber upper",
"comemierda",
"comepinga",
"comte audoin de dampierre",
"comte de dampierre",
"con",
"conard",
"concha",
"concha de tu madre",
"conchieur",
"connard",
"connasse",
"conne",
"cono",
"coã±o",
"convalmore",
"coochie",
"coochy",
"coon",
"cooranbong",
"cooter",
"corralejo",
"corzo",
"couille",
"couillon",
"courvoisier",
"courvosier",
"cow",
"cracker",
"cracovia",
"cragganmore",
"craigellachie",
"crap",
"crappy",
"cržtin",
"cržtine",
"crevard",
"crve",
"crevure",
"cristian senez",
"croizet",
"crotte",
"cruz tequila",
"crystal head",
"culera",
"culeras",
"culero",
"culeros",
"culiado",
"culo",
"cul-sec",
"cum",
"cum chugger",
"cum freak",
"cum guzzler",
"cum guzzling cock sucker",
"cumbubble",
"cumdumpster",
"cumguzzler",
"cumjockey",
"cumjunkie",
"cummer",
"cumming",
"cums",
"cumshot",
"cumslut",
"cumtart",
"cunilingus",
"cunillingus",
"cunnie",
"cunnilingus",
"cunt",
"cunt face",
"cunt hole",
"cuntass",
"cuntbag",
"cuntee",
"cuntface",
"cunthole",
"cuntlick",
"cuntlicker",
"cuntlicking",
"cuntrag",
"cunts",
"cuntsicle",
"cuntslut",
"cunt-struck",
"cuperly",
"cyberfuc",
"cyberfuck",
"cyberfucked",
"cyberfucker",
"cyberfuckers",
"cyberfucking",
"d4mn",
"dago",
"dailuaine",
"dalaruan",
"dalintober",
"dallas dhu",
"dalmore",
"dalwhinnie",
"damn",
"daniel bouju",
"danzka",
"darn",
"das arschloch",
"das ist mir furzegal",
"das ist mir scheiãÿegal",
"daygo",
"de castellane",
"de cazanove",
"de telmont",
"de venoge",
"deanston",
"džbile",
"džbile profond",
"dã‰cada tequila",
"džcžržbrž",
"džchet",
"deep eddy",
"džfrisž du cortex",
"džgžnžrž",
"džgeuler",
"deggo",
"dego",
"degueulasse",
"džgueulasse",
"džgueulis",
"deine mutter schwitzt beim kacken",
"delamain",
"delamotte",
"delbeck",
"deleã³n tequila",
"demetrio",
"denis-mouniž",
"depp",
"džpravž",
"der abschaum",
"der abschaum der menschlichen gesellschaft",
"der arsch",
"der drecksack",
"der dreckskerl",
"der schwanz",
"der schwanzlutscher",
"der teufel",
"der teufel wird los sein",
"deregard massing",
"desgraciado",
"desmoulins",
"džtritus",
"deumeurž",
"deutz",
"devanha",
"diablo",
"dick",
"dick hole",
"dick sucker",
"dickbag",
"dickbeaters",
"dickface",
"dickfuck",
"dickfucker",
"dickhead",
"dickhole",
"dickjuice",
"dickmilk",
"dickmonger",
"dicks",
"dickslap",
"dick-sneeze",
"dicksucker",
"dicksucking",
"dicktickler",
"dickwad",
"dickweasel",
"dickweed",
"dickwod",
"did he bollocks",
"did i fuck as like",
"die fotze",
"die fregatte",
"die hure",
"die mã¶pse",
"die scheiãÿe",
"die schlampe",
"die titten",
"dike",
"dild0",
"dildo",
"dildos",
"dilld0",
"dink",
"dinks",
"dipshit",
"dirsa",
"dirty bitch",
"domaine le reviseur",
"dominatricks",
"dominatrics",
"dominatrix",
"don eduardo",
"don julio",
"don pilar",
"don weber",
"dong",
"donkey punch",
"doochbag",
"dookie",
"dos lunas tequila",
"dosnon & lepage",
"dot au",
"double cross",
"douche",
"douche bag",
"douchebag",
"douche-fag",
"douchewaffle",
"dovgan",
"downunder",
"dragon bleu",
"drappier",
"dreckige hure",
"drecksau",
"drinking",
"drogas",
"drouet et fils",
"drumguish",
"drunk",
"du alte kackbratze!",
"du arschgefickter hurensohn",
"du bastard",
"du bist ein volltrottel",
"du blã¶de stinkfotze",
"du drecksack",
"du dumme kuh",
"du fickfehler",
"du hã¤ssliger ziegenficker",
"du hurensohn",
"du kannst mich mal",
"du muschi",
"du musst selbstmord begehen",
"du schweinehund",
"du verdammter arschficker",
"du verdammtes arschloch",
"du verdreht missgeburt",
"du weichei",
"dubra",
"ducon",
"dufftown",
"dugland",
"dulce vida tequila",
"dumass",
"dumb ass",
"dumb bitch",
"dumbarton",
"dumbass",
"dumbfuck",
"dumbshit",
"dummbatz",
"dumme kuh",
"dumme schlampe",
"dummes huhn",
"dummkopf",
"dumshit",
"duncauf",
"dundalk",
"dundashill",
"dupa",
"dupuy",
"duval-leroy",
"dyke",
"dziwka",
"e. normandin",
"eat a dick",
"eat fur pie",
"eat hair pie",
"ecervelž",
"ectoplasme",
"edradour",
"ejackulate",
"ejaculate",
"ejaculated",
"ejaculates",
"ejaculating",
"ejaculatings",
"ejakulate",
"ekrem",
"ekto",
"el gran jurado",
"el jefe",
"el jimador",
"el tesoro tequila",
"emmerde",
"emmerdeur",
"emmerdeuse",
"emmmerderesse",
"empaffž",
"empotž",
"enculž",
"enculer",
"enculeur",
"enculeuse",
"enfler",
"enflure",
"eristoff",
"espolon",
"ess scheisse",
"ess scheisse und stirb",
"estve",
"eugne ralle",
"excellia tequila",
"explorer",
"f***",
"f****n",
"f**k",
"face de bidet",
"face de cul",
"face de pet",
"facho",
"facialize",
"fada",
"faen",
"fag",
"fag1t",
"fagbag",
"faget",
"fagfucker",
"fagg1t",
"fagget",
"fagging",
"faggit",
"faggot",
"faggotcock",
"faggs",
"fagit",
"fagot",
"fagots",
"fags",
"fagtard",
"fahr zur holle",
"faig",
"faignasse",
"fainžant",
"fanculo",
"fanny",
"fart",
"farted",
"farting",
"fartings",
"farts",
"farty",
"faschiste",
"fatass",
"fatso",
"fcuk",
"feces",
"feck",
"feedbag material",
"feg",
"felatio",
"felch",
"felcher",
"felching",
"fellatio",
"feltch",
"ferintosh",
"fesse",
"fettbacke",
"fettercairn",
"fich dich der arschfotze",
"fick deine mutter",
"fick dich",
"fick dich arschloch",
"fick dich ins knie",
"fick dich!",
"fick dich",
"fickdich",
"ficken",
"ficken rossette",
"ficker",
"fickfresse",
"fiente",
"fils de pute",
"fingerfuck",
"fingerfucked",
"fingerfucker",
"fingerfuckers",
"fingerfucking",
"fingerfucks",
"finlandia",
"fiote",
"fiotte",
"firefly",
"fist fuck",
"fistfuck",
"fistfucked",
"fistfucker",
"fistfuckers",
"fistfucking",
"fistfuckings",
"fistfucks",
"fitt",
"flamer",
"flange",
"flaps",
"fleet support unit",
"fleischmann's",
"flikker",
"foireux",
"foldingue",
"fotze",
"fotze",
"foucauld",
"fouquet couzin",
"frapin",
"frederic couzin",
"frida kahlo tequila",
"frigide",
"frã¯s",
"fuck",
"fuck hole",
"fuck me in the ass with no vaseline",
"fuck off",
"fuck puppet",
"fuck yo mama",
"fuckass",
"fuckbag",
"fuckboy",
"fuckbrain",
"fuckbutt",
"fuckbutter",
"fucked",
"fucker",
"fuckers",
"fuckersucker",
"fuckface",
"fuckhead",
"fuckhole",
"fuckin",
"fucking",
"fucking cunt",
"fucking pussy",
"fucking retard",
"fuckings",
"fuckme",
"fuckmeat",
"fucknut",
"fucknutt",
"fuckoff",
"fucks",
"fuckstick",
"fucktard",
"fucktart",
"fucktoy",
"fuckup",
"fuckwad",
"fuckwit",
"fuckwitt",
"fudgepacker",
"fuenteseca tequila",
"fugging",
"fuk",
"fukah",
"fukd",
"fuked",
"fuken",
"fuker",
"fukin",
"fuking",
"fukk",
"fukkah",
"fukken",
"fukker",
"fukkin",
"fuks",
"fumier",
"furburger",
"furoncle",
"fusion",
"futkretzn",
"fux0r",
"fvck",
"g.h. martel & co.",
"g00k",
"gangbang",
"gangbang",
"gangbanged",
"gangbangs",
"gangrne",
"ganja",
"garage ã bite",
"gardet",
"gash",
"gauthier",
"gautier",
"gay",
"gayass",
"gaybob",
"gaydo",
"gayfuck",
"gayfuckist",
"gaylord",
"gaytard",
"gaywad",
"gayz",
"gazongers",
"geh ein schwanz lutschen",
"geh' kacken",
"geh' 'ne kuh melken",
"geh staub fressen",
"geh zum teufel",
"geil",
"gendarmette",
"gerston",
"get (one's) redwings",
"get brain",
"get some squish",
"geudin",
"gilipolla",
"gilipollas",
"ginger",
"girvan",
"git",
"glandeur",
"glandus",
"glass bottom boat",
"glen",
"glen albyn",
"glen deveron",
"glen elgin",
"glen garioch",
"glen grant",
"glen keith",
"glen mhor",
"glen moray",
"glen nevis",
"glen ord",
"glen rothes",
"glen scotia",
"glen spey",
"glenaden",
"glenallachie",
"glenburgie",
"glencadam",
"glencoe",
"glencraig",
"glendarroch",
"glendronach",
"glendullan",
"glenesk",
"glenfarclas",
"glenfiddich",
"glenforres",
"glenfoyle",
"glenfyne",
"glengalwan",
"glenglassaugh",
"glengoyne",
"glenguin",
"glengyle",
"gleniffer",
"glenkinchie",
"glenlivet",
"glenlochy",
"glenlossie",
"glenmavis",
"glenochil",
"glenordie",
"glens",
"glenside",
"glentarras",
"glentauchers",
"glenturret",
"glenugie",
"glenury royal",
"gluon",
"gmilf",
"gob shite",
"god",
"goddam",
"goddamn",
"goddamnit",
"godet",
"godsdamn",
"gogol",
"gold symphony",
"gonads",
"gooch",
"gook",
"gorbatschow",
"gosset",
"got a squirrel peeking",
"gottverdammt",
"gouine",
"gourdasse",
"grand con",
"grand niais",
"grand teton",
"grandtully",
"grange",
"graveleux",
"greenall's",
"greenock",
"grey goose",
"gringo",
"grognasse",
"grosperrin",
"gueudin",
"gueulard",
"gueule",
"gueusquin",
"gã¼evon",
"guido",
"guiena",
"guignol",
"guillon-painturaud",
"guinne",
"h00r",
"h0ar",
"h0r",
"h0re",
"h4x0r",
"hacienda san josž de miravalle",
"hackfresse",
"hairy axe wound",
"halal",
"hallal",
"halt de fick klappe",
"halt deine fresse",
"halt die fresse",
"ham flap",
"han",
"handjob",
"hangar 1",
"hankey bannister",
"haram",
"hard on",
"hardy",
"harram",
"hash",
"hatchet wound",
"have (one's) peanut butter stirred",
"have a face like a hatful of assholes",
"hazelburn",
"heeb",
"heidsieck & co monopole",
"hell",
"helvete",
"hemped up",
"henri giraud",
"henriot",
"herradura",
"highland park",
"hija de puta",
"hijo de puta",
"hillside",
"himmel",
"hine",
"hirnlose ochse",
"hitler",
"hoar",
"hobknocker",
"hoe",
"hoer",
"hoes",
"hoez",
"hokkaido",
"hole",
"hã¶lle",
"holy shit",
"homo",
"homodumbshit",
"homofuerst",
"honkey",
"hooghoudt",
"hooker",
"hoor",
"hoore",
"hore",
"horniest",
"hornitos",
"horny",
"horst",
"hotsex",
"hrenovuha",
"huan",
"huan son",
"huebo",
"huebos",
"huevo",
"huevon",
"huevã³n",
"huevos",
"huhrensohn",
"hui",
"humping",
"hurensohn",
"hussy",
"hydrocžphale",
"iceberg",
"ich fick deine mutter",
"ich ficke deine mutter",
"ich ficke deine schwester",
"ich hasse dich",
"ich will dich ficken",
"ich will ficken",
"idiot",
"ignare",
"illettrž",
"imbžcile",
"imbibž",
"imperial",
"impuissant",
"inchgower",
"inchmurrin",
"infame",
"injun",
"inãºtil",
"inverarity",
"invergordon",
"inverleven",
"irroy",
"isensua",
"isla",
"isle of jura",
"ivernel",
"ivrogne",
"j dupont",
"j g monnet",
"j j mortier",
"j ordonneau",
"jack off",
"jackass",
"jacking",
"jacking off",
"jackoff",
"jack-off",
"jacquart",
"jacquesson",
"jacquinot & fils",
"jaggoff",
"jagoff",
"jah das ist spãƒâ¤ter",
"jap",
"japseye",
"jean fillioux",
"jean-marc",
"jeeper",
"jenssen",
"jerk",
"jerk off",
"jerkass",
"jerk-off",
"jesus",
"jesus christ",
"jesus h. christ",
"jesus wept",
"jesus",
"jigaboo",
"jisim",
"jism",
"jiss",
"jiz",
"jizm",
"jizz",
"jode su madre",
"joder",
"johns lane",
"jones' road",
"jose cuervo",
"joseph perrier",
"joto",
"juarez",
"judas priest",
"jungle bunny",
"junglebunny",
"kackbratze",
"kah tequila",
"kanker",
"karlssons",
"karuizawa",
"kauffman",
"kawk",
"keglevich",
"kess emma",
"kess emmak",
"ketel one",
"khlibnyi dar",
"khortytsa",
"kihnu mark",
"kike",
"kinclaith",
"kininvie",
"kinloch",
"kintyre",
"kirkland signature",
"kirkliston",
"kiss ekhta",
"kiss emma",
"kiss emmak",
"kissui",
"kkk",
"kleiner feigling",
"klootzak",
"knob",
"knobend",
"knockando",
"knockdhu",
"knulle",
"kock",
"kooch",
"kootch",
"kors vodak",
"korski",
"koskenkorva",
"kraut",
"krupnik",
"kryshtal etalon",
"kubanskaya",
"kuk",
"kuksuger",
"kum",
"kummer",
"kumming",
"kums",
"kunilingus",
"kunt",
"kurac",
"kurwa",
"kush",
"kusi",
"kyke",
"kyrpa",
"l ducasse",
"l3itch",
"la pouyade",
"la primo de pancho",
"la puta madre que te pariã³",
"la3net",
"ladyburn",
"lagavulin",
"laideron",
"lameass",
"langholm",
"lanson",
"laphroaig",
"lardass",
"larve",
"latvijas balzams",
"laurent-perrier",
"l'chaim",
"lea valley",
"lech mien arsch",
"lche bite",
"lche cul",
"leche-boules",
"lche-cul",
"leck mich",
"leck mich am arsch!",
"ledaig",
"lefoulon",
"lemoine",
"lenoble",
"leopold bros.",
"leopold gourmel",
"lesbian",
"lesbo",
"level",
"leyrat",
"lezzian",
"lezzie",
"lheraud",
"lick au mosh",
"lick my froth",
"like fucking a dying man's handshake",
"limavady",
"limerick",
"links traeger",
"linkwood",
"lipshits",
"lipshitz",
"littlemill",
"lmao",
"lmfao",
"lms",
"loch katrine",
"lochead",
"lochindaal",
"lochnagar",
"lochranza",
"lochruan",
"lochside",
"lokka",
"lombard & cie",
"lomond",
"longmorn",
"longrow",
"lopette",
"loquedu",
"los osuna",
"lotus",
"louis baron",
"louis de sacy",
"louis roederer",
"louis royer",
"lude",
"luder",
"luksusowa",
"lunazul",
"lutsch mein' schwanz",
"lutsch' meine eier",
"macallan",
"macduff",
"madrear",
"maestro dobel tequila",
"magic spirits",
"maleta",
"maleton",
"malt mill",
"mamada",
"mamadas",
"mamagã¼evo",
"mamar",
"mamarracho",
"mamavergas",
"mamen",
"mames",
"mamez",
"mamhoon",
"mammouth",
"mamon",
"mamã³n",
"mamã³n",
"man chowder",
"mange-merde",
"maniak",
"mannochmore",
"mansard baillet",
"manyakeh",
"maria pascuala tequila",
"marica",
"maricon",
"maricã³n",
"marie couche-toi-lã",
"marie stuart",
"marihuana",
"marijuana",
"marin d'eaudouce",
"marnier",
"marrowbone lane",
"martell",
"masochism",
"masochist",
"masochistic",
"masokist",
"massterbait",
"masstrbait",
"masstrbate",
"masterbaiter",
"masterbat",
"masterbat3",
"masterbate",
"masturbat",
"masturbiert",
"maxime trijol",
"mcfagget",
"me cago",
"meat drapes",
"meat flap",
"mercier roger",
"merd",
"merdasse",
"merde",
"merdeux",
"merlet",
"meukow",
"meunier & cie",
"mibun",
"michel couprie",
"michel forgeron",
"mick",
"midleton",
"mierda",
"mieser stricher",
"milagro",
"millburn",
"milltown",
"milton keith",
"miltonduff",
"minge",
"minger",
"minsk kristall",
"missgeburt",
"miststã¼ck",
"moffat",
"mofo",
"mojon",
"mojã³n",
"molle",
"monasterevan",
"mongol",
"monkeytits",
"monkleigh",
"mononeuronal",
"monopolowa",
"montaudon",
"monte carlo",
"montifaud",
"mortlach",
"morue",
"morveux",
"moskovskaya",
"mosstowie",
"motha fucker",
"motha fuker",
"motha fukkah",
"motha fukker",
"mothafuck",
"mothafucka",
"mothafuckas",
"mothafuckaz",
"mothafucked",
"mothafucker",
"mothafuckers",
"mothafuckin",
"mothafucking",
"mothafuckings",
"mothafucks",
"mother fucker",
"mother fukah",
"mother fuker",
"mother fukkah",
"mother fukker",
"motherfuck",
"motherfucked",
"motherfucker",
"mother-fucker",
"motherfucker",
"motherfuckers",
"motherfuckin",
"motherfucking",
"motherfucking",
"motherfuckings",
"motherfucks",
"mou du genou",
"mouche ã merde",
"moule",
"mouliewop",
"mountain wolf",
"moutard-diligent",
"muchote",
"mudblut hure",
"muff",
"muffdiver",
"muie",
"mulkku",
"mumm",
"munging",
"munter",
"murder",
"murge",
"murree",
"muschi",
"muschi lecker",
"muterfiker",
"mutha",
"mutha fucker",
"mutha fukah",
"mutha fuker",
"mutha fukkah",
"mutha fukker",
"mutterficker",
"n*gga",
"n1gr",
"nabot",
"nain de jardin",
"narodnaya",
"nastt",
"naze",
"nazi",
"nazillon",
"nžcrophile",
"negro",
"nemiroff",
"nepesaurio",
"nevis",
"ngga",
"ni**a",
"nicolas feuillatte",
"nigaboo",
"nigaud",
"nigga",
"nigger",
"niggers",
"niglet",
"nigur",
"niiger",
"niigr",
"nikolai",
"nique",
"niquer",
"nombrilo-contemplatif",
"nonce",
"nono",
"normandin-mercier",
"north british",
"north mall",
"north of scotland",
"north port",
"nucka",
"nun's island",
"nunuche",
"nut butter",
"nut sack",
"nutle",
"nutsack",
"nuttensohn",
"oban",
"obsždž",
"off",
"ogete",
"ogetes",
"ojete",
"ojetes",
"olmeca tequila",
"onanieren",
"orafis",
"ord",
"ordure",
"organic",
"orgasim",
"orgasims",
"orgasm",
"orgasms",
"orgasum",
"oriface",
"orifice",
"orifiss",
"orloff",
"orospu",
"oso negro",
"otard",
"outre",
"p.i.n.k vodka",
"p0rn",
"p3n1s",
"p3nis",
"packi",
"packie",
"packy",
"pajero",
"paki",
"pakie",
"paky",
"panooch",
"parasite",
"parkmore",
"paska",
"patate",
"patrã³n",
"paul beau",
"paul giraud",
"paul goerg",
"pecker",
"peckerhead",
"pžcore",
"pždale",
"pedazo de mierda",
"pždž",
"pedofile",
"pždoncule",
"pždoque",
"pedorro",
"peeenus",
"peenus",
"peigne cul",
"peinus",
"pen1s",
"penas",
"pendeja",
"pendejada",
"pendejadas",
"pendejas",
"pendejo",
"pendejos",
"penguin",
"penis",
"penisbanger",
"penisfucker",
"penispuffer",
"penus",
"penuus",
"pepe lopez",
"pžquenot",
"perra",
"perra",
"perrier-jouã«t",
"perro",
"perse",
"pervers",
"pestbaeule",
"pet",
"pžtasse",
"petit con",
"petite bite",
"pžtochard",
"philipponnat",
"phoenix park",
"phuc",
"phuck",
"phuk",
"phuked",
"phuking",
"phukked",
"phukker",
"phukking",
"phuks",
"phuq",
"piaff",
"picka",
"pico",
"pierdol",
"pierre ferrand",
"pierre mignon",
"pignouf",
"pija",
"pillu",
"pimmel",
"pimp",
"pimpin",
"pimpis",
"pimppin",
"pinche",
"pinches",
"pine",
"pine d'huitre",
"pinet castillon",
"pinga",
"pinky vodka",
"pinnacle",
"piper-heidsieck",
"piruja",
"pirujas",
"piss",
"piss off",
"pisse",
"pissed",
"pissed off",
"pissed/pissed off",
"pisser",
"pissers",
"pisses",
"pisseuse",
"pisseux",
"pissflaps",
"piss-flaps",
"pissin",
"pissing",
"pissoff",
"pissrr",
"pitilie",
"pito",
"pitos",
"pittyvaich",
"pizda",
"platinka",
"play the five-fingered flute",
"plonker",
"plouc",
"ploucocrate",
"poire",
"poivreau",
"pol roger",
"polac",
"polack",
"polak",
"polar ice",
"polesmoker",
"pollock",
"polonaise",
"poltron",
"pommery",
"pompe",
"poof",
"poon",
"poonani",
"poonany",
"poontang",
"poontsee",
"poop",
"popov",
"porc",
"porch monkey",
"porchmonkey",
"port dundas",
"port ellen",
"pouf",
"pouffe",
"pouffiasse",
"pouilleux",
"pourceau",
"pourriture",
"poxy",
"pr0n",
"pr1c",
"pr1ck",
"pr1k",
"prick",
"pricks",
"prickteaser",
"profanity",
"projectile",
"provanmill",
"prunier",
"pube",
"pue",
"puke",
"pula",
"pule",
"pulteney",
"punaise",
"puã±al",
"puã±ales",
"punani",
"punanny",
"puã±eta",
"punny",
"punta",
"pura vida tequila",
"purity vodka",
"puss",
"pusse",
"pussee",
"pussey",
"pussies",
"pussy",
"pussy fart",
"pussylicking",
"pussys",
"puta",
"puta madre",
"putain",
"putain de ta race",
"putas",
"putassire",
"pute",
"putinka",
"putisima",
"putã­sima",
"putisimas",
"putã­simas",
"putisimo",
"putã­simo",
"putisimos",
"putã­simos",
"puto",
"putona",
"putos",
"putržfaction",
"puuke",
"puuker",
"pyatizvyozdnaya",
"qahbeh",
"queef",
"queer",
"queerbait",
"queerhole",
"queerz",
"qužquette",
"queutard",
"quiche",
"qweers",
"qweerz",
"qweir",
"racaille",
"race",
"rachmaninoff",
"racist",
"raclure",
"raclure de bidet",
"raclure de chiottes",
"radasse",
"radi",
"ragnaud sabourin",
"ragondin",
"rain",
"ramassi",
"randy",
"rapey",
"rastaquoure",
"rat arsed",
"rat mort",
"rature",
"rautenberg",
"recktum",
"remy couillebaud",
"ržmy martin",
"renat",
"renžgat",
"renž-james lallier",
"renob",
"ržsidu",
"ržsidu de branlotte",
"ržsidus",
"restant de fausse-couche",
"retard",
"reyka",
"rhosdhu",
"rieclachan",
"rimjob",
"roast beef curtains",
"rodnik",
"rokk",
"romanov",
"rosebank",
"rouyer",
"royal irish distilleries",
"royaliste",
"ruski",
"ruskova",
"russian standard",
"rusty trombone",
"s***",
"s**t",
"sac",
"sac ã foutre",
"sac ã merde",
"salaud",
"sale",
"saletž",
"saligaud",
"salignac",
"salon",
"salopard",
"salope",
"saloperie",
"salopiaud",
"saltinbanque",
"samovar",
"sand nigger",
"sandnigger",
"santera tequila",
"saoul",
"saoã»les",
"saperlipopette",
"saucel",
"sausage queen",
"sauza tequila",
"savvy",
"sazerac de forge",
"scank",
"scapa",
"scelerat",
"schaffer",
"scheiss",
"scheiãÿe",
"scheissekopf",
"scheissen",
"scheiãÿhaus",
"scheiãÿkopf",
"schise",
"schlampe",
"schlampe",
"schlong",
"schlong juice",
"schmuck",
"schramm organic",
"schwanz lecker",
"schwanzlutscher",
"schweinepriester",
"schwuchtel",
"schwul",
"schwuler",
"scotia",
"screw",
"scrote",
"scrotum",
"selosse",
"semen",
"seã±or rã­o",
"sex",
"sh!t",
"sh1t",
"sh1ter",
"sh1tter",
"shaisa",
"sharmouta",
"sharmuta",
"sharmute",
"sheisse",
"sheister",
"shemale",
"shinga",
"shingaa",
"shipal",
"shishkoff",
"shit",
"shit ass",
"shit fucker",
"shitass",
"shitbag",
"shitbagger",
"shitbrains",
"shitbreath",
"shitcanned",
"shitcunt",
"shitdick",
"shite",
"shitface",
"shitfaced",
"shitfull",
"shithead",
"shithole",
"shithouse",
"shiting",
"shitings",
"shits",
"shitspitter",
"shitstain",
"shitted",
"shitter",
"shittiest",
"shitting",
"shitty",
"shity",
"shiz",
"shiznit",
"sht",
"shum",
"shustov",
"shyt",
"shyte",
"shytt",
"shytty",
"shyty",
"siwucha",
"skanck",
"skank",
"skankee",
"skankey",
"skanky",
"skeet",
"skullfuck",
"skyy",
"slag",
"slaptard",
"slich",
"slut",
"slutbag",
"slutty",
"smackgead",
"smeg",
"smegma",
"smirnoff",
"smoke a sausage",
"smut",
"snatch",
"snow queen",
"snowball",
"so ein beschiãÿ!",
"sobieski",
"sod-off",
"sodomite",
"sohn einer hã¼ndin",
"sol de mexico tequila",
"son of a bitch",
"son of a motherless goat",
"son of a whore",
"son-of-a-bitch",
"soplica",
"souillon",
"soyuz-viktan",
"spermatozoide",
"speyburn",
"speyside",
"spic",
"spick",
"splooge",
"spook",
"springbank",
"springside",
"spunk",
"square one organic",
"squeeze a steamer",
"st. magdalene",
"starka",
"steig auf diese hoden",
"stick it up your arse",
"stolichnaya",
"stolnaya",
"strathclyde",
"strathdee",
"strathisla",
"strathmill",
"strathmore",
"strathspey",
"strã¶m",
"stromness",
"stumbras",
"stupide",
"suce",
"suceur de quenelle",
"suck a dick",
"suck a fat baby's dick",
"suckasss",
"svedka",
"sweet jesus",
"taaka",
"tafiole",
"taittinger",
"talisker",
"tambowie",
"tamdhu",
"tamnavulin",
"tanteo tequila",
"tantouse",
"tantouze",
"tapette",
"tapin",
"tard",
"tarž",
"tarlouze",
"tart",
"tartignole",
"teaninich",
"teets",
"teez",
"tentouse",
"tequila camarena",
"tequila celestial",
"tequila corralejo",
"tequila don weber",
"tequila tromba",
"tesseron",
"testical",
"testicles",
"tte de gland",
"tte de nå“ud",
"the irish distilleries",
"thižnot",
"thomas street",
"thon",
"three olives",
"thundercunt",
"thundercunt",
"ti",
"tierras tequila",
"tiffon",
"tit",
"titfuck",
"tito's",
"tits",
"titt",
"tittie christ",
"titties",
"titty",
"tittyfuck",
"tobermory",
"tocard",
"toff",
"tomatin",
"tomintoul",
"tonto",
"tonto del culo",
"tormore",
"tosser",
"towiemore",
"traã®ne",
"trainže",
"traã®nže",
"tres agaves",
"tres generaciones",
"tributo tequila",
"tricard",
"troll",
"tromblon",
"tronche",
"tronche de cake",
"tronche de pain sucž",
"trottel",
"trou",
"trou ã bite",
"trou du cul",
"troud'balle",
"ts",
"tullamore",
"tullibardine",
"tunte",
"turd",
"twat",
"twatlips",
"twats",
"twatwaffle",
"twonk",
"u fukin wanker",
"ultimat",
"unclefucker",
"unwaschen ficken jude",
"urine",
"ursus",
"uv",
"v44",
"va1jina",
"vã„d",
"vag",
"vag1na",
"vagiina",
"vagina",
"vaj1na",
"vajayjay",
"vajina",
"va-j-j",
"van gogh",
"vandale",
"varpiss dich!",
"vaurien",
"vautour",
"vauxhall",
"veganer",
"verdammt du hurensohn",
"verdammte scheiãÿe!",
"verficktes arschloch!",
"verga",
"vergas",
"verhurtes drecksgã¶r",
"verpiss dich",
"verpiss dich!",
"very fine",
"vete a la mierda",
"veuve cheurlin",
"vicelard",
"vikingfjord",
"villa lobos",
"vilmart",
"viru valge",
"vjayjay",
"vka vodka",
"vladivar",
"vodka 14",
"vodka mariette",
"voegeln (vã¶geln)",
"vomir",
"vomit",
"voodoo tiki",
"vox",
"vranken",
"vullva",
"vulva",
"w00se",
"w0p",
"wank",
"wanker",
"wankjob",
"wankstain",
"wasted",
"waterside",
"webo",
"webos",
"weed",
"wertlos kind",
"wetback",
"wevo",
"wevos",
"wh00r",
"wh0re",
"white mischief",
"whoar",
"whore",
"whorebag",
"whoreface",
"wichs container!",
"wichsen",
"wichser",
"wilde tier schwarze affee arschloch",
"wisent",
"wixer",
"wodka",
"wop",
"wtf",
"wyborowa",
"xan",
"xellent swiss",
"xrated",
"xxx",
"yamazaki",
"yayo",
"yel3an",
"yoker",
"youri dolgoruki",
"z (end marker)",
"zaber",
"zaranoff",
"zeig mir deine pflaume!",
"zicke",
"zickig",
"zimtzicke",
"zodiac",
"zoladkowagorzka",
"zorra",
"zorra",
"zorras",
"zubrã³wkacoke",
"zur holle mit dir"
];
    const reEscape = s => s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    const badWordsRE = new RegExp(customSwears.map(reEscape).join('|'));
    let txt = jQuery(this).val().toLowerCase();
    let found = txt.match(badWordsRE);
    console.log(txt, jQuery(this).val().match(badWordsRE));
    if (found != null) {
      jQuery(this).val('');
    }
    jQuery(this).val(jQuery(this).val().replace( /[^a-zA-Z0-9\' ]/gm, ''));
    
    // Now trigger the change to update the image
    jQuery(this).trigger('change');
  })*/ 

});

function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}